export default [
  {
    path: "campaign-addon",
    name: "campaignAddon",
    component: () =>
      import("@/views/adminPanel/pages/addone/CampaignAddon.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "cloud-addon",
    name: "cloudAddon",
    component: () =>
      import("@/views/adminPanel/pages/addone/CampaignAddon.vue"),
    meta: {
      rule: "editor",
    },
  },

  // {
  //   path: "add-Ons",
  //   name: "Add-Ons",
  //   component: () => import("@/views/adminPanel/pages/addone/Addone.vue"),
  //   meta: {
  //     rule: "editor",
  //   },
  // },

  {
    path: "add-Ons",
    name: "Add-Ons",
    component: () => import("@/views/adminPanel/pages/addone/Addone.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "add-ons/addonsdetail",
    name: "Add-ons-AddonsDetailSummary",
    component: () =>
      import(
        "@/views/adminPanel/pages/addone/components/AddonsDetailSummary.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "add-ons/my-addons",
    name: "Add-ons-myaddons",
    component: () =>
      import("@/views/adminPanel/pages/addone/components/MyAddonsDetails.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "add-ons/my-request",
    name: "Add-ons-myrequest",
    component: () =>
      import("@/views/adminPanel/pages/addone/components/MyRequestAddon.vue"),
    meta: {
      rule: "editor",
    },
  },
];
